import * as ReduxInputs from './ReduxInputs';

export default ReduxInputs;
